<form
  [formGroup]="form"
  [mojoFormConnect]="job"
>
  <div>

    <div class="row">
      <mat-form-field
        color="accent"
        class="col-12"
      >
        <mat-label>Job title</mat-label>
        <input
          matInput
          type="text"
          formControlName="title"
          autocomplete="off"
          id="title"
          data-cy="basic-job-name-input"
          required
        />
      </mat-form-field>
    </div>
    <div class="row">
      <mojo-multiple-location-input
        class="col-12 m-bottom-0"
        label="Location"
        [isMaterial]="true"
        [form]="form"
        controlName="locationInput"
        data-cy="basic-job-location-input"
        [isRequired]="isRequired"
      >
      </mojo-multiple-location-input>
      <mat-checkbox
        formControlName="remote"
        data-cy="basic-job-remote"
        class="remote"
      >
        Remote
      </mat-checkbox>
    </div>

    <div class="row ">
      <mojo-numeric-input
        label="Number of openings"
        color="accent"
        [min]="1"
        class="col-6 col-lg-4"
        formControlName="numberOfPositions"
        data-cy="basic-job-number-of-openings"
      >
      </mojo-numeric-input>

      <mat-form-field
        color="accent"
        class="col-6 col-lg-4"
      >
        <mat-label>Target date</mat-label>
        <input
          matInput
          [matDatepicker]="picker"
          formControlName="date"
          placeholder="mm/dd/yyyy"
          data-cy="basic-jobs-target-date-input"
        >
        <mat-datepicker-toggle
          matSuffix
          [for]="picker"
        ></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>
  </div>

  <mat-divider></mat-divider>

  <h3>Client details</h3>
  <div class="row">
    <div class="col-12 col-lg-6">
      <mojo-autocomplete
        (inputChange)="getCompanyAutocompleteList($event)"
        [multi]="false"
        [options]="companyService.filteredOptions$ | async"
        appearance="fill"
        bindLabel="label"
        [useChips]="false"
        color="accent"
        data-cy="basic-job-company-autocomplete-input"
        formControlName="company"
        label="Company"
        placeholder="Company"
        required="true"
      >
        <ng-template
          #avatarTmpl
          let-option
        >
          <common-mojo-avatar
            class="option-avatar"
            [selectedPhotoShape]="avatarPhotoShape"
            [id]="option?.imageId"
            [initials]="option.capitals"
          ></common-mojo-avatar>
        </ng-template>
      </mojo-autocomplete>
    </div>
    <div class="col-12 col-lg-6">
      <mojo-autocomplete
        (inputChange)="getManagerAutocompleteList($event)"
        [multi]="false"
        [options]="companyManagerService.filteredOptions$ | async"
        appearance="fill"
        bindLabel="label"
        [useChips]="false"
        color="accent"
        data-cy="basic-job-manager-autocomplete-input"
        formControlName="companyManager"
        label="Manager"
        placeholder="Start typing..."
        required="true"
        [keepPanelOpenOnSelection]="true"
      >
        <ng-template
          #avatarTmpl
          let-option
        >
          <common-mojo-avatar
            class="option-avatar"
            [selectedPhotoShape]="avatarPhotoShape"
            [id]="option?.imageId"
            [initials]="option.capitals"
          ></common-mojo-avatar>
        </ng-template>
      </mojo-autocomplete>
    </div>
  </div>

  <div class="row">
    <mat-form-field
      color="accent"
      class="col-6 col-lg-4"
    >
      <mat-label>Client req ID</mat-label>
      <input
        matInput
        autocomplete="off"
        formControlName="clientReqId"
        id="clientReqId"
        name="clientReqId"
        data-cy="client-req-id-input"
      />
    </mat-form-field>
  </div>

  <mat-divider></mat-divider>

  <h3>Salary</h3>

  <div class="row">
    <mat-form-field
      color="accent"
      class="col-12 col-lg-6"
    >
      <mat-label>Job type</mat-label>
      <mat-select
        formControlName="jobType"
        (selectionChange)="changeJobType()"
        data-cy="basic-job-job-type-select"
        required
      >
        <mat-option
          *ngFor="let item of jobTypesList"
          [value]="item"
        >
          {{ item }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div data-cy="job-basic-job-type-bin">
    <div *ngIf="isJobType([jobTypes.Temporary, jobTypes.SOW])">
      <mojo-job-salary-temporary-contract
        [form]="form"
        [isSowTemplate]="isJobType(jobTypes.SOW)"
        (timePeriodChange)="timePeriodChange($event)"
      >
      </mojo-job-salary-temporary-contract>
    </div>

    <div
      class="item"
      *ngIf="isJobType([jobTypes.FullTime])"
    >
      <mojo-job-salary-full-time [form]="form"></mojo-job-salary-full-time>
    </div>

    <div
      class="item"
      *ngIf="isJobType([jobTypes.PartTime])"
    >
      <mojo-job-salary-part-time [form]="form"></mojo-job-salary-part-time>
    </div>

    <div
      class="item"
      *ngIf="!!jobType?.value && isJobType([jobTypes.Direct])"
    >
      <mojo-job-salary-direct [form]="form"></mojo-job-salary-direct>
    </div>

  </div>

</form>
